if (!customElements.get("store-select")) {
	customElements.define(
		"store-select",
		class StoreSelect extends HTMLElement {
			constructor() {
				super()

				this.select = this.querySelector("select")

				this.addEventListener("click", (e) => {
					const item = e.target.closest(".store-select__item")

					if (item) {
						const url = item.dataset.value
						window.location = url
					}

					// const close = e.target.closest(".icon-close")

					// if (close) {
					// 	const modal = this.querySelector("details-modal")
					// 	modal.close()
					// }
				})

				var init = this.init.bind(this)
				init()
			}

			init() {
				//init to ensure current store is selected
				var options = this.querySelectorAll("option")

				options.forEach((option, index) => {
					let value = option.value

					if (value == window.location.origin) {
						this.select.selectedIndex = index
					}
				})
			}
		}
	)
}
//df
